import { useLocale } from "../../../../hooks/useLocale";
import { msg } from "../../../../locales/translate";
import { Box, VBox } from "@ui/box/Box";
import { Select } from "@ui/select/Select";
import { Typo } from "@ui/text/Typo";
import { ITheme } from "@ui/theme/GlobalTheme";
import { useEffect, useState } from "react";
import { GD } from "src/GD";
import { ITerminal } from "src/types/types";
import { useTheme } from "styled-components";

interface IMerchantTerminalSelectorProps {
	merchant: IMerchantModel;
	disabled?: boolean;
}

export const MerchantTerminalSelector = ({
	merchant,
	disabled,
}: IMerchantTerminalSelectorProps) => {
	useLocale();
	const theme = useTheme() as ITheme;

	//const [terminals] = GD.B_GROUPS.use({ clientID: clientID });
	const [terminals] = GD.B_TERMINALS.use({ ts: +new Date() });
	const [selected, setSelected] = useState<ITerminal | undefined>();

	useEffect(() => {
		if (terminals?.data && merchant !== null) {
			const selectedGroup = terminals.data.find(
				g => g.id === merchant.terminal_id
			);
			if (selectedGroup) {
				setSelected(selectedGroup);
			}
		}
	}, [terminals]);

	const onChange = async (m: ITerminal) => {
		merchant.terminal_id = m.id;
	};

	return (
		<Box
			sx={{
				alignItems: "center",
				borderRadius: "8px",
				display: "flex",
			}}>
			{terminals?.data && (
				<VBox gap="3px">
					<Typo variant="caption" sx={{ display: "inline" }}>{msg("setChannelTerminal")}</Typo>
					<Select
						disabled={disabled}
						sx={{
							boxShadow: "none",
							border: `1px solid ${theme.colors.divider}`,
							gap: "20px",
							minWidth: "250px",
							borderRadius: "12px",
							height: "40px",
						}}
						sheetAlign="left"
						onChange={e => {
							onChange(e);
						}}
						value={selected}
						values={terminals.data}
						// item={<MonthSelectorItem prompt />}
					/>
				</VBox>
			)}
		</Box>
	);
};
